/* eslint-disable react/jsx-no-undef */
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import ReactGA from 'react-ga4';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import ScrollToTop from './components/ScrollToTop';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import { ChartStyle } from './components/chart';
import AuthModal from './components/modals/AuthModal/AuthModal';
import CreditInfo from './components/modals/CreditsModal/CreditInfo';
import ThemeSettings from './components/settings';
import BannerContainer from './components/modals/Banner/BannerContainer';
import SuspensionBlocker from './SuspensionBlocker';
import { PageCampusProvider } from './contexts/PageCampusContext';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(GA_MEASUREMENT_ID);
} else {
  console.error('GA_MEASUREMENT_ID is missing');
}

export default function App() {
  useEffect(() => {
    if (GA_MEASUREMENT_ID) {
      ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
    }
  }, []);

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <PageCampusProvider>
          <NotistackProvider>
            <ProgressBarStyle />
            <ChartStyle />
            <ScrollToTop />
            
            {/* SuspensionBlocker wraps everything that should be blocked */}
            <SuspensionBlocker>
              <BannerContainer>
                <Router />
              </BannerContainer>
            </SuspensionBlocker>
            
          </NotistackProvider>
          </PageCampusProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}